import {
  Directive,
  Input,
  OnDestroy,
  OnInit,
  TemplateRef,
  ViewContainerRef,
} from '@angular/core';
import { Store } from '@ngrx/store';
import { Roles } from '@utils/roles';
import { Subject, takeUntil } from 'rxjs';
import { AppUser } from '@modules/company-manager/users/domain';
import { appAuthenticatedUserSelector } from '@core/application';

@Directive({
  selector: '[showOnRole]',
})
export class ShowOnRoleDirective implements OnInit, OnDestroy {
  private readonly destroy$ = new Subject<void>();
  private currentUser: AppUser | null = null;
  private permissions: string = '';

  constructor(
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef,
    private store$: Store
  ) {}

  ngOnInit(): void {
    this.store$
      .select(appAuthenticatedUserSelector)
      .pipe(takeUntil(this.destroy$))
      .subscribe((user) => {
        this.currentUser = user;
        this.updateView();
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  @Input()
  set showOnRole(roles: string) {
    this.permissions = roles;
    this.updateView();
  }

  private updateView(): void {
    this.viewContainer.clear();
    if (this.checkPermissions()) {
      this.viewContainer.createEmbeddedView(this.templateRef);
    }
  }

  private checkPermissions(): boolean {
    const roles = this.currentUser?.roles;
    if (!roles) {
      return false;
    }

    if (roles.includes(Roles.companyAdministrator)) {
      return true;
    }

    if (
      roles.includes('approver') &&
      roles.includes('requester') &&
      roles.includes(this.permissions)
    ) {
      return true;
    }

    return roles.includes(this.permissions);
  }
}
